// Other
import { inject, observer } from 'mobx-react'
import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { WorkPageWrapper } from './ManagementAssetWarehouseStylePage'
import DashboardLayout from '../../layouts/DashboardLayout'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { runInAction } from 'mobx'
import ManagementAssetWarehouseTable from './ManagementAssetWarehouseTable'
// Ant design
import {
  Button,
  Menu,
  message,
  Modal,
  Col,
  Form,
  Input,
  Row,
  Select,
} from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import ManagerInventoryTemplateList from '../ManagerInventoryPage/ManagerInventoryTemplateList'
// Component
import PageTitle from '../../components/PageTitle'
import AppPageHeader from '../../components/AppPageHeader'

// Other
import AccessControlAction from '../../components/AccessControlAction'
import ManagementAssetWarehouseCreate from './ManagementAssetWarehouseCreate'
import { ACL_ACTION_TYPE } from '../../constants'
import ManagementAssetWarehouseUnitCreate from './ManagementAssetWarehouseUnitCreate'
import ManagementAssetWarehouseUnitTable from './ManagementAssetWarehouseUnitTable'
import moment from 'moment'
import {
  AddCircleOutlineIcon,
  MagnifierOutlineIcon,
} from '../../components/AppIcon'
import queryString from 'query-string'
import { useHistory, useLocation, Link } from 'react-router-dom'
import { pickBy } from 'lodash'

const ManagementAssetWarehouseUnitPage = props => {
  const { managementAssetWarehouseStore } = props || {}
  const [isVisibleCreateModal, setIsVisibleCreateModal] = useState(false)
  const [currentDate] = useState(moment(new Date()).format('MM-YYYY'))
  const [isLoading, setIsLoading] = useState(false)

  const handleToggleCreateModal = bool => event => {
    setIsVisibleCreateModal(bool)
  }

  const history = useHistory()
  const location = useLocation()
  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  const onSearch = values => {
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        description: values?.trim() || null,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )
    history.push(
      `/manager-inventory/manage-inventory-asset?${queryStringStringify}`
    )
  }

  const loadManagerAssetTypeList = async () => {
    try {
      setIsLoading(true)
      const queryParams = {
        page: queryStringParse?.page || 0,
        size: queryStringParse?.size || 10,
        description: queryStringParse?.description || null,
      }
      const formattedQueryString = queryString.stringify(
        pickBy(queryParams, v => v != null)
      )

      await managementAssetWarehouseStore.fetchManagementAssetTypeListV2(
        formattedQueryString
      )
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    void loadManagerAssetTypeList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryStringParse])

  return (
    <WorkPageWrapper>
      <DashboardLayout>
        <Helmet>
          <title>Hành chính | Quản lý kho | Loại văn phòng phẩm</title>
        </Helmet>

        <AppPageHeader
          title="Loại văn phòng phẩm"
          addon={
            <>
              <Input.Search
                allowClear
                onSearch={onSearch}
                defaultValue={queryStringParse?.description}
                maxLength={500}
                placeholder="Tìm kiếm theo nội dung"
                enterButton={
                  <MagnifierOutlineIcon
                    style={{ color: '#000', width: 16, height: 16 }}
                  />
                }
                className="custom-search-input fixed-width"
              />
              <AccessControlAction check={true}>
                <Button
                  className="custom-ant-button icon-btn "
                  type={'primary'}
                  icon={
                    <AddCircleOutlineIcon
                      style={{ color: '#fff', width: 16, height: 16 }}
                    />
                  }
                  onClick={handleToggleCreateModal(true)}>
                  Tạo mới
                </Button>
              </AccessControlAction>
            </>
          }
        />

        <ContentBlockWrapper>
          <Menu
            className="custom-menu-tab"
            mode="horizontal"
            selectedKeys={props?.location?.pathname}
            style={{ marginBottom: 16 }}>
            <Menu.Item key="/manager-inventory/inventory-asset">
              <Link to={'/manager-inventory/inventory-asset'}>Tài sản</Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/manage-inventory-asset">
              <Link to={'/manager-inventory/manage-inventory-asset'}>
                Loại văn phòng phẩm
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/statistic">
              <Link to={'/manager-inventory/statistic'}>
                Thống kê tài sản tháng {currentDate}
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/export-statistic">
              <Link to={'/manager-inventory/export-statistic'}>
                Báo cáo sử dụng văn phòng phẩm theo tháng {currentDate}
              </Link>
            </Menu.Item>
          </Menu>

          <ManagementAssetWarehouseUnitTable
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            handleRefreshData={loadManagerAssetTypeList}
          />
        </ContentBlockWrapper>
      </DashboardLayout>
      <Modal
        width={600}
        wrapClassName="custom-modal-wrapper"
        title={'Tạo mới loại văn phòng phẩm'}
        visible={isVisibleCreateModal}
        maskClosable={false}
        onCancel={handleToggleCreateModal(false)}
        footer={null}
        destroyOnClose>
        {isVisibleCreateModal && (
          <ManagementAssetWarehouseUnitCreate
            onCancel={handleToggleCreateModal(false)}
            onCreateSuccess={loadManagerAssetTypeList}
          />
        )}
      </Modal>
    </WorkPageWrapper>
  )
}

export default inject(
  'managementAssetWarehouseStore',
  'loadingAnimationStore',
  'authenticationStore',
  'notificationStore',
  'selectPeopleStore'
)(observer(ManagementAssetWarehouseUnitPage))
